module.exports = __webpack_public_path__ + "img/banner05_info3.70824754.svg";